//deps
import styled from "styled-components";

// internal deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const iconContainerHeight = 24;
const iconContainerWidth = 36;
const methodCountWidth = 36;

export const Container = styled.div`
    padding: ${props => props.theme.spacing.large} ${props => props.theme.spacing.medium};
    text-align: center;
    color: ${props => props.theme.colors[props.theme.colorMode].text_Button_Secondary};
    display: flex;
    align-items: center;
`;

export const MethodCount = styled(Text)`
    text-align: center;
    width: ${methodCountWidth}px;
    border: 1px solid ${props => props.theme.colors[props.theme.colorMode].border_Secondary};
    border-radius: ${props => props.theme.cornerRadius.xSmall};
    padding: ${props => props.theme.spacing.xxSmall} 0;
    color: ${props => props.theme.colors[props.theme.colorMode].text_Button_Secondary};
    text-transform: uppercase;
`;

export const Icon = styled.div`
    width: ${iconContainerWidth}px};
    height: ${iconContainerHeight}px;
    border-radius: ${props => props.theme.cornerRadius.xSmall};
    border: 1px solid ${props => props.theme.colors[props.theme.colorMode].border_Secondary};
`;

export const MethodBody = styled(Text)`
    padding: 0 ${props => props.theme.spacing.medium};
`;

export const GenericIconContainer = styled(GenericIcon)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
